// Service Records workflow mode helpers.
//
// `Mode` + `modeLabel()` live in a pure-TS file (not in ui.tsx) so
// node-only test files in tests/web/ can import them without dragging
// in JSX. The component definitions (RecordHeader, ModeShell) stay in
// ui.tsx and re-export these symbols for ergonomic consumption.
//
// The three workflow modes — Opportunity (blue) / Processing (amber) /
// Ongoing Care (green) — are the heart of the Service Records visual
// system. See web/src/design/tokens.ts `modes` constant for the color
// values and the design_handoff_service_records README for the design
// rationale.

export type Mode = "opp" | "proc" | "care";

/**
 * User-facing labels for each workflow mode.
 *
 * The singular form is shown on RecordHeader's mode pill ("Opportunity").
 * The plural form is the navigation label ("Opportunities" / "Processing" /
 * "Ongoing Care") per vocabulary-system-v1.4.
 */
export const MODE_LABEL: Record<Mode, string> = {
  opp: "Opportunity",
  proc: "Processing",
  care: "Ongoing Care",
};

/** Human-readable label for a workflow mode. */
export function modeLabel(mode: Mode): string {
  return MODE_LABEL[mode];
}
